import React from 'react';

const Page5Rating = ({ 
  treatmentRatings,
  updateTreatmentRating,
  handlePrevious,
  handleNext,
  isMobile
}) => {
  return (
    <>
      <div className={`questions-grid ${isMobile ? 'mobile-grid' : ''}`}>
        <div className="question-item full-width">
          <label>On a scale of 0-10, how satisfied are you with the treatment plan provided by Cloudphysician's physicians' team?</label>
          <div className="nps-scores">
            {[...Array(11)].map((_, index) => (
              <button
                key={index}
                className={`score-button ${treatmentRatings.treatmentPlan === index ? 'selected' : ''}`}
                onClick={() => updateTreatmentRating('treatmentPlan', index)}
              >
                {index}
              </button>
            ))}
          </div>
          <p className="rating-description">
          0 = Not at all satisfied, 10 = Extremely satisfied
          </p>
        </div>

        <div className="question-item full-width">
          <label>On a scale of 0-10, how satisfied are you with patient health improvement?</label>
          <div className="nps-scores">
            {[...Array(11)].map((_, index) => (
              <button
                key={index}
                className={`score-button ${treatmentRatings.healthImprovement === index ? 'selected' : ''}`}
                onClick={() => updateTreatmentRating('healthImprovement', index)}
              >
                {index}
              </button>
            ))}
          </div>
          <p className="rating-description">
            0 = Not at all satisfied, 10 = Extremely satisfied
          </p>
        </div>

        <div className="question-item full-width">
          <label>On a scale of 0-10, how satisfied are you with Cloudphysician's hourly monitoring?</label>
          <div className="nps-scores">
            {[...Array(11)].map((_, index) => (
              <button
                key={index}
                className={`score-button ${treatmentRatings.hourlyMonitoring === index ? 'selected' : ''}`}
                onClick={() => updateTreatmentRating('hourlyMonitoring', index)}
              >
                {index}
              </button>
            ))}
          </div>
          <p className="rating-description">
            0 = Not at all satisfied, 10 = Extremely satisfied
          </p>
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNext}
          disabled={treatmentRatings.treatmentPlan === null || 
                   treatmentRatings.healthImprovement === null || 
                   treatmentRatings.hourlyMonitoring === null}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page5Rating;
